import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.4737 7.52441C15.888 6.93862 14.9382 6.93862 14.3524 7.52441C13.7666 8.11019 13.7666 9.05994 14.3524 9.64573C14.9382 10.2315 15.888 10.2315 16.4737 9.64573C17.0595 9.05994 17.0595 8.11019 16.4737 7.52441Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.0028 1.99757L22.811 12.5032L11.8791 23.435L0.56543 12.1213L11.4973 1.18945L22.0028 1.99757ZM13.292 6.46375C12.1205 7.63532 12.1205 9.53482 13.292 10.7064C14.4636 11.878 16.3631 11.878 17.5347 10.7064C18.7063 9.53482 18.7063 7.63532 17.5347 6.46375C16.3631 5.29218 14.4636 5.29218 13.292 6.46375Z"}}]};

const DiscountFilled = Vue.extend<IconProps>({
  name: 'DiscountFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'discount-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DiscountFilled;
